import { Zap, MapPin, BadgeCheck, ShieldCheck, ClipboardList, HandCoins } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const REASONS = [
  { icon: Zap, title: "Rapidité suprême", desc: "30 minutes en moyenne pour les réparations courantes, sans rendez-vous obligatoire." },
  { icon: MapPin, title: "Expertise Haute-Savoie", desc: "Un atelier local à Saint-Pierre-en-Faucigny, au plus près de chez vous." },
  { icon: BadgeCheck, title: "Pièces qualité certifiée", desc: "Des pièces sélectionnées et testées, jamais au détriment de la durabilité." },
  { icon: ShieldCheck, title: "Garantie 1 an", desc: "Pièces et main d'œuvre garanties un an. Si ça revient, on reprend sans frais." },
  { icon: ClipboardList, title: "Devis 100% gratuit", desc: "Diagnostic et devis gratuits, sans engagement. Le prix est confirmé avant travaux." },
  { icon: HandCoins, title: "Prix justes", desc: "Des tarifs transparents et compétitifs, annoncés à l'avance, sans surprise." },
];

export default function WhyUs() {
  return (
    <section id="pourquoi" className="border-y border-line bg-ink py-24 lg:py-32">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-8">
        <SectionHead
          tag="Pourquoi MAXREVIX"
          title={<>La confiance, <span className="text-neon">c'est notée</span></>}
          sub="Six engagements simples, tenus à chaque intervention."
        />

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={i * 0.06}>
              <div className="h-full rounded-2xl border border-line bg-night p-7 transition-colors duration-300 hover:border-neon/40">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-neon/25 bg-neon/10 text-neon">
                  <r.icon size={22} />
                </span>
                <h3 className="mt-5 font-display text-xl font-bold uppercase tracking-tight text-white">{r.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{r.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mx-auto mt-10 max-w-3xl text-center text-sm leading-relaxed text-slate-400">
            <strong className="font-semibold text-white">MAXREVIX en bref :</strong> diagnostic 29 € déduits en cas de réparation, garantie 1 an
            pièces et main d'œuvre, réparations courantes en 30 à 60 minutes sous vos yeux, devis toujours confirmé avant toute intervention, et
            paiement uniquement après validation du résultat.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
